import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class ImportListVm {
	importHistoryId: number;
	vendorName?: string;
	dateReceived?: Date;
	dateReceivedString?: string;
	sftpFileName?: string;
	excelDownloadFileName?: string;
	excelUploadFileName?: string;
	pdfDownloadFileName?: string;
	status?: string;
	totalRecords: number;
	mailedRecords: number;
	totalRecordsString?: string;
	mailedRecordsString?: string;
	returnUploadFileName?: string;
	actionHistory?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'importHistoryId': new UntypedFormControl(0, [...(validators['importHistoryId'] ?? []), ...[Validators.required]]),
			'vendorName': new UntypedFormControl(null, [...(validators['vendorName'] ?? []), ...[]]),
			'dateReceived': new UntypedFormControl(null, [...(validators['dateReceived'] ?? []), ...[]]),
			'dateReceivedString': new UntypedFormControl(null, [...(validators['dateReceivedString'] ?? []), ...[]]),
			'sftpFileName': new UntypedFormControl(null, [...(validators['sftpFileName'] ?? []), ...[]]),
			'excelDownloadFileName': new UntypedFormControl(null, [...(validators['excelDownloadFileName'] ?? []), ...[]]),
			'excelUploadFileName': new UntypedFormControl(null, [...(validators['excelUploadFileName'] ?? []), ...[]]),
			'pdfDownloadFileName': new UntypedFormControl(null, [...(validators['pdfDownloadFileName'] ?? []), ...[]]),
			'status': new UntypedFormControl(null, [...(validators['status'] ?? []), ...[]]),
			'totalRecords': new UntypedFormControl(0, [...(validators['totalRecords'] ?? []), ...[Validators.required]]),
			'mailedRecords': new UntypedFormControl(0, [...(validators['mailedRecords'] ?? []), ...[Validators.required]]),
			'totalRecordsString': new UntypedFormControl(null, [...(validators['totalRecordsString'] ?? []), ...[]]),
			'mailedRecordsString': new UntypedFormControl(null, [...(validators['mailedRecordsString'] ?? []), ...[]]),
			'returnUploadFileName': new UntypedFormControl(null, [...(validators['returnUploadFileName'] ?? []), ...[]]),
			'actionHistory': new UntypedFormControl(null, [...(validators['actionHistory'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['vendorName', {"orderId":0,"sortColumn":"vendorName","searchColumn":"vendorName","includeInExcel":true,"exportColumn":null,"displayName":"VendorName","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['dateReceived', {"orderId":1,"sortColumn":"dateReceived","searchColumn":"dateReceivedString","includeInExcel":true,"exportColumn":null,"displayName":"Date Received","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['sftpFileName', {"orderId":2,"sortColumn":"sftpFileName","searchColumn":"sftpFileName","includeInExcel":true,"exportColumn":null,"displayName":"SFTP File Name","isVisible":false,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['excelDownloadFileName', {"orderId":3,"sortColumn":"excelDownloadFileName","searchColumn":"excelDownloadFileName","includeInExcel":true,"exportColumn":null,"displayName":"Excel Download","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}],
			['excelUploadFileName', {"orderId":4,"sortColumn":"excelUploadFileName","searchColumn":"excelUploadFileName","includeInExcel":true,"exportColumn":null,"displayName":"Excel Upload","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['pdfDownloadFileName', {"orderId":5,"sortColumn":"pdfDownloadFileName","searchColumn":"pdfDownloadFileName","includeInExcel":true,"exportColumn":null,"displayName":"PDF Download","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}],
			['status', {"orderId":6,"sortColumn":"status","searchColumn":"status","includeInExcel":true,"exportColumn":null,"displayName":"Status","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['totalRecords', {"orderId":7,"sortColumn":"totalRecords","searchColumn":"totalRecordsString","includeInExcel":true,"exportColumn":null,"displayName":"Total Records","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['mailedRecords', {"orderId":8,"sortColumn":"mailedRecords","searchColumn":"mailedRecordsString","includeInExcel":true,"exportColumn":null,"displayName":"Records Mailed","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['returnUploadFileName', {"orderId":9,"sortColumn":"returnUploadFileName","searchColumn":"returnUploadFileName","includeInExcel":true,"exportColumn":null,"displayName":"Return Upload","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}],
			['actionHistory', {"orderId":10,"sortColumn":"actionHistory","searchColumn":"actionHistory","includeInExcel":true,"exportColumn":null,"displayName":"Action History","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): ImportListVmFromFg {
		return new ImportListVmFromFg(fg);
	}
}

export class ImportListVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get importHistoryId(): number {
		return this.fg.get('importHistoryId').value;
	}
	set importHistoryId(val) {
		this.fg.get('importHistoryId').setValue(val);
	}

	get vendorName(): string {
		return this.fg.get('vendorName').value;
	}
	set vendorName(val) {
		this.fg.get('vendorName').setValue(val);
	}

	get dateReceived(): Date {
		return this.fg.get('dateReceived').value;
	}
	set dateReceived(val) {
		this.fg.get('dateReceived').setValue(val);
	}

	get dateReceivedString(): string {
		return this.fg.get('dateReceivedString').value;
	}
	set dateReceivedString(val) {
		this.fg.get('dateReceivedString').setValue(val);
	}

	get sftpFileName(): string {
		return this.fg.get('sftpFileName').value;
	}
	set sftpFileName(val) {
		this.fg.get('sftpFileName').setValue(val);
	}

	get excelDownloadFileName(): string {
		return this.fg.get('excelDownloadFileName').value;
	}
	set excelDownloadFileName(val) {
		this.fg.get('excelDownloadFileName').setValue(val);
	}

	get excelUploadFileName(): string {
		return this.fg.get('excelUploadFileName').value;
	}
	set excelUploadFileName(val) {
		this.fg.get('excelUploadFileName').setValue(val);
	}

	get pdfDownloadFileName(): string {
		return this.fg.get('pdfDownloadFileName').value;
	}
	set pdfDownloadFileName(val) {
		this.fg.get('pdfDownloadFileName').setValue(val);
	}

	get status(): string {
		return this.fg.get('status').value;
	}
	set status(val) {
		this.fg.get('status').setValue(val);
	}

	get totalRecords(): number {
		return this.fg.get('totalRecords').value;
	}
	set totalRecords(val) {
		this.fg.get('totalRecords').setValue(val);
	}

	get mailedRecords(): number {
		return this.fg.get('mailedRecords').value;
	}
	set mailedRecords(val) {
		this.fg.get('mailedRecords').setValue(val);
	}

	get totalRecordsString(): string {
		return this.fg.get('totalRecordsString').value;
	}
	set totalRecordsString(val) {
		this.fg.get('totalRecordsString').setValue(val);
	}

	get mailedRecordsString(): string {
		return this.fg.get('mailedRecordsString').value;
	}
	set mailedRecordsString(val) {
		this.fg.get('mailedRecordsString').setValue(val);
	}

	get returnUploadFileName(): string {
		return this.fg.get('returnUploadFileName').value;
	}
	set returnUploadFileName(val) {
		this.fg.get('returnUploadFileName').setValue(val);
	}

	get actionHistory(): string {
		return this.fg.get('actionHistory').value;
	}
	set actionHistory(val) {
		this.fg.get('actionHistory').setValue(val);
	}
}
